<div class="card dashed bg-transparent">
  <div class="card-body">
    <p><ng-content></ng-content></p>
    <hr />
    <div class="d-flex gap-3 align-items-center">
      <ion-icon name="add-circle-outline" class="fs-4"></ion-icon>
      {{ "click_to_add" | translate }}
    </div>
  </div>
</div>
